const root = "LoginHelpScreen";

const LoginHelpEvents = {
    CLICK: `${root}.click`,
    CTA_BUTTON: `${root}.ctaButton`
};

export default LoginHelpEvents;
